module.exports = require('./helpers/bundle-url').getBundleURL('17nMI') + "blog-4.7bf9876a.jpeg" + "?" + Date.now();